import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MatTabGroup } from '@angular/material';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { element } from '@angular/core/src/render3/instructions';
// import { exit } from 'process';

@Component({
  selector: 'app-tour-prog',
  templateUrl: './tour-prog.component.html',
  styleUrls: ['./tour-prog.component.css']
})
export class TourProgComponent implements OnInit {

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  // heightField = '';

  //Tables & Data:
  public add_city_list = [];
  public add_bus_list = [];
  private add_age_list = [];
  private add_room_list = [];
  private add_hotel_list = [];
  private add_hotel_room_list = [];
  private trip_tax = {};

  selectedTab = 0;

  cityDataSource = new MatTableDataSource(this.add_city_list);
  busDataSource = new MatTableDataSource(this.add_bus_list);
  ageDataSource = new MatTableDataSource(this.add_age_list);
  roomDataSource = new MatTableDataSource(this.add_room_list);
  cityHotelDataSource = new MatTableDataSource(this.add_hotel_list);
  hotelRoomDataSource = new MatTableDataSource(this.add_hotel_room_list);
  @ViewChild(MatSort) sort: MatSort;

  cityDisplayedColumns = ['city_name', 'arrival_date', 'depart_date', 'days_num', 'nights_num', 'night_cost', 'edit', 'del'];
  busDisplayedColumns = ['bus_no', 'depart_date', 'return_date', 'from_city_name', 'to_city_name', 'edit', 'del'];
  ageDisplayedColumns = ['period_from', 'period_to', 'price_bed', 'price_no_bed', 'edit', 'del'];
  roomDisplayedColumns = ['room_type', 'room_price', 'room_cost', 'edit', 'del'];
  cityHotelDisplayedColumns = ['city_name', 'arrival_date', 'depart_date', 'hotel_name', 'edit', 'del'];
  hotelRoomDisplayedColumns = ['hotel_name', 'arrival_date', 'depart_date', 'room_type', 'room_count', 'edit', 'del'];

  //Models:

  model = {
    'dep_year': '', 'dep_month': '', 'dep_day': '', 'ret_year': '',
    'ret_month': '', 'ret_day': '', 'rem_count': '0', 'country_id': '', 'price_with_tax': '0',
    'pass_only': '', 'city_total': '', 'bus_seat': '', 'food_cost_w_tax': '', 'ext_bed_price': '',
    'room_type_id': '', 'visa_cost_w_tax': '', 'ticket_cost_w_tax': '', 'room_cost_w_tax': '',
    'ticket_tax_no': '', 'food_tax_no': '', 'visa_tax_no': '', 'room_tax_no': '', 'city_tax_no': '',
    'visa_price_tax': '', 'food_price_tax': '', 'seat_price_tax': '', 'bed_price_tax': ''
  };

  trip_model = {
    'table_name': 'trip', 'trip_id': '0', 'category_id': '0', 'trip_name': '', 'trip_number': '',
    'agent_only': '0', 'departure_date': '', 'arrival_date': '', 'active': '1', 'hijri_departure_date': '',
    'hijri_arrival_date': '', 'visitors_number': '0', 'trip_activity': '', 'days_number': '', 'nights_num': '',
    'departure_time': '', 'arrival_time': '', 'bed_price': '0', 'bed_cost': '0', 'bed_calc_tax': '0',
    'bed_tax_amount': '0', 'bed_supplier_no': '', 'trip_price': '0', 'airline_id': '0', 'ticket_inc': '0',
    'hotel_inc': '0', 'price_type': 'room', 'not_mand_cust_info': '0', 'ticket_cost': '0', 'ticket_calc_tax': '0',
    'ticket_tax_amount': '0', 'ticket_supplier_no': '', 'food_price': '0', 'food_cost': '0', 'food_calc_tax': '0',
    'food_tax_amount': '0', 'food_supplier_no': '', 'visa_price': '0', 'visa_cost': '0', 'visa_calc_tax': '0',
    'visa_tax_amount': '0', 'visa_supplier_no': '', 'price_for_tax': '0', 'tax_type': 'all_price', 'tax_no': '0',
    'flag': 'new', 'key': 'trip_id', 'tax_comment': '', 'price_comment': '', 'seat_price': '0', 
    'cost_center': '0', 'cond_list_id': '0', 'comment': ''
  };
  // , 'branch_id': this.applicationConstants.user_branch_info.user_branch_id

  city_model = { 
    'table_name': 'trip_city', 'trip_city_id': '0', 'trip_id': '0', 'city_id': '0', 'arrival_date': '',
    'depart_date': '', 'days_num': '0', 'nights_num': '0', 'transport_type': '', 'depart_airport_id': '0',
    'depart_time': '', 'has_flight': '', 'night_cost': '0', 'calc_tax': '0', 'tax_amount': '0',
    'flag': 'new', 'key': 'trip_city_id', 'supplier_no': '', 'program': '', 'comment': '', 'city_name': '',
    'country_id': ''
  };

  city_hotel_model = {
    'table_name': 'trip_city_hotel', 'trip_hotel_id': '0', 'trip_id': '0', 'country_id': '0',
    'city_index': '', 'city_id': '0', 'hotel_id': '0', 'arrival_date': '', 'depart_date': '',
    'flag': 'new', 'key': 'trip_hotel_id', 'comment': '', 'hotel_name': '', 'hotel_name_en': '',
    'city_name': '', 'city_name_en': ''
  };

  hotel_room_model = {
    'table_name': 'trip_hotel_room', 'trip_room_id': '0', 'trip_id': '0', 'hotel_index': '', 
    'hotel_id': '0', 'arrival_date': '', 'depart_date': '', 'room_type_id': '0', 'room_count': '0', 'flag': 'new', 
    'key': 'trip_room_id', 'comment': '', 'hotel_name': '', 'hotel_name_en': '', 'room_type': ''
  };

  cc_model = {
    'table_name': 'cost_center', 'cc_id': '0', 'cc_number': '', 'cc_name': '', 'cc_name_en': '', 
    'cc_desc': '', 'cc_date': '', 'flag': 'new', 'key': 'cc_id', 'comment': ''
  };

  date_model = {
    'departure_date': new Date(), 'arrival_date': new Date(), 'bus_dep_date': new Date(),
    'bus_ret_date': new Date(), 'city_arr_date': new Date(), 'city_dep_date': new Date()
  };

  bus_model = {
    'table_name': 'trip_bus', 'trip_bus_id': '0', 'trip_id': '0', 'bus_id': '0', 'depart_date': '',
    'return_date': '', 'flag': 'new', 'key': 'trip_bus_id', 'from_city': '0', 'to_city': '0',
    'comment': '', 'bus_no': '', 'from_city_name': '', 'from_city_name_en': '', 'to_city_name': '',
    'to_city_name_en': ''
  };

  age_price_model = {
    'table_name': 'trip_price', 'trip_price_id': '0', 'trip_id': '0', 'period_from': '', 'period_to': '',
    'price_bed': '', 'bed_cost': '0', 'bed_calc_tax': '0', 'bed_tax_amount': '0', 'bed_supplier_no': '0',
    'price_no_bed': '', 'no_bed_cost': '0', 'no_bed_calc_tax': '0', 'no_bed_tax_amount': '0',
    'flag': 'new', 'key': 'trip_price_id', 'no_bed_supplier_no': '0', 'comment': '',
    'price_bed_tax': '', 'price_no_bed_tax': ''
  };

  room_price_model = {
    'table_name': 'trip_room_price', 'room_price_id': '0', 'trip_id': '0', 'room_type_id': '0',
    'room_price': '', 'room_cost': '0', 'room_calc_tax': '0', 'room_tax_amount': '0', 'room_price_tax': '0',
    'flag': 'new', 'key': 'room_price_id', 'room_supplier_no': '', 'comment': '', 'room_type': ''
  };

  //Edit:

  id = '';
  mode = '';
  trip_info = {};
  trip_city = [];
  trip_city_hotel = [];
  trip_hotel_room = [];
  trip_bus = [];
  trip_room = [];
  trip_age_price = [];
  tax_edit_info = [];

  //Select Lists:

  cat_list = [];
  airline_list = [];
  invCondList = [];
  country_list = [];
  city = [];
  city_list = [];
  bus_list = [];
  room_list = [];
  city_tax = [];
  city_hotel = [];
  hotels = [];
  hotel_list = [];

  firstVisit = true;
  airline_detail = '';
  tax_detail = '';
  from_city_detail = '';
  to_city_detail = '';
  toDelete = [];

  status_list = [{ 'status_id': '1', 'status_name': 'مفعل', 'status_name_en': 'Active' },
    { 'status_id': '0', 'status_name': 'غير مفعل', 'status_name_en': 'Inactive' }];
    
    // { 'status_id': '2', 'status_name': 'مخصص للوكلاء فقط', 'status_name_en': 'For Agents Only' },

  year_list = ['1442', '1443', '1444', '1445', '1446', '1447', '1448', '1449', '1450'];
  month_list = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  day_list = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
    '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
    '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'];

  trans_list = [{ 'key': 'bus', 'trans_name': 'باص', 'trans_name_en': 'Bus' },
    { 'key': 'plane', 'trans_name': 'طائرة', 'trans_name_en': 'Plane' }];


  //Search Objects:

  search_tax = {
    'placeholder': 'رقم الضريبة/ اسم الضريبة', 'class_name': 'midField',
    'table_list': [{
      'table_name': '`tax`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'tax_name_ar', 'tax_name_en']
    }]
  };

  search_supplier = {
    'placeholder': 'رقم المورد/ اسم المورد', 'class_name': 'midField',
    'table_list': [{
      'table_name': '`supplier`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'supplier_name', 'supplier_name_en']
    }]
  };

  search_airport = {
    'placeholder': 'المطار', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': '`airport`', 'selected_no': 'airport_id',
      'field_list': ['airport_code', 'airport_name', 'airport_name_en', 'airport_code']
    }]
  };

  search_airline = {
    'placeholder': 'اسم الشركة', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': 'airline', 'selected_no': 'airline_id',
      'field_list': ['airline_name', 'airline_name_en']
    }]
  };

  search_city = {
    'placeholder': 'اسم المدينة', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': '`city`', 'selected_no': 'city_id',
      'field_list': ['city_name', 'city_name_en']
    }]
  };

  //Translate:
  Supplier_Placeholder; Tax_Placeholder; Airport; Staff_Placeholder;
  City_Msg; Del_City_Msg; Bus_Msg; Del_Bus_Msg; Price_Msg;
  Room_Type_Msg; Room_Count_Msg; Del_Price_Msg; Date_Msg; Success_Msg; Error_Msg;
  Del_Room_Msg; Tax_Msg; Hotel_Msg; From_Age_Msg; To_Age_Msg;

  // search_admin = {
  //   'placeholder': 'الاسم/ رقم الجوال', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`staff`', 'selected_no': 'staff_id',
  //     'field_list': ['staff_name', 'staff_name_en', 'staff_mobile1']
  //   }]
  // };

  // search_male = {
  //   'placeholder': 'الاسم/ رقم الجوال', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`staff`', 'selected_no': 'staff_id',
  //     'field_list': ['staff_name', 'staff_name_en', 'staff_mobile1'],
  //     'condition': " AND `staff`.`gender` = 'm'"
  //   }]
  // };

  // search_female = {
  //   'placeholder': 'الاسم/ رقم الجوال', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`staff`', 'selected_no': 'staff_id',
  //     'field_list': ['staff_name', 'staff_name_en', 'staff_mobile1'],
  //     'condition': " AND `staff`.`gender` = 'f'"
  //   }]
  // };

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private route: ActivatedRoute, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Supplier_Placeholder').subscribe((res: string) => {
      this.Supplier_Placeholder = res;
    });
    this.search_supplier['placeholder'] = this.Supplier_Placeholder;

    translate.get('Tax_Placeholder').subscribe((res: string) => {
      this.Tax_Placeholder = res;
    });
    this.search_tax['placeholder'] = this.Tax_Placeholder;

    translate.get('Airport').subscribe((res: string) => {
      this.Airport = res;
    });
    this.search_airport['placeholder'] = this.Airport;

    translate.get('Staff_Placeholder').subscribe((res: string) => {
      this.Staff_Placeholder = res;
    });
    // this.search_admin['placeholder'] = this.Staff_Placeholder;
    // this.search_male['placeholder'] = this.Staff_Placeholder;
    // this.search_female['placeholder'] = this.Staff_Placeholder;

    translate.get('City_Msg').subscribe((res: string) => {
      this.City_Msg = res;
    });

    translate.get('Del_City_Msg').subscribe((res: string) => {
      this.Del_City_Msg = res;
    });

    translate.get('Bus_Msg').subscribe((res: string) => {
      this.Bus_Msg = res;
    });

    translate.get('Del_Bus_Msg').subscribe((res: string) => {
      this.Del_Bus_Msg = res;
    });

    translate.get('Price_Msg').subscribe((res: string) => {
      this.Price_Msg = res;
    });

    translate.get('Room_Type_Msg').subscribe((res: string) => {
      this.Room_Type_Msg = res;
    }); 

    translate.get('Room_Count_Msg').subscribe((res: string) => {
      this.Room_Count_Msg = res;
    });

    translate.get('Del_Price_Msg').subscribe((res: string) => {
      this.Del_Price_Msg = res;
    });

    translate.get('Date_Msg').subscribe((res: string) => {
      this.Date_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Room_Msg').subscribe((res: string) => {
      this.Del_Room_Msg = res;
    });

    translate.get('Tax_Msg').subscribe((res: string) => {
      this.Tax_Msg = res;
    });

    translate.get('Hotel_Msg').subscribe((res: string) => {
      this.Hotel_Msg = res;
    });

    translate.get('From_Age_Msg').subscribe((res: string) => {
      this.From_Age_Msg = res;
    });

    translate.get('To_Age_Msg').subscribe((res: string) => {
      this.To_Age_Msg = res;
    });
  }


  ngOnInit() {
    //------------------------ Get All Select lists ------------------------//
    let query, obj;

    query = "SELECT * FROM `category` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cat_list = data.data['list'];
      });

    query = "SELECT * FROM `airline` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.airline_list = data.data['list'];
      });

    query = this.queryList.all_invCondList + " AND (`branch_id` = '0' OR `branch_id` = '" + 
      this.applicationConstants.user_branch_info.user_branch_id + "')";
    obj = { cmd: 'getList', query: query };
    
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.invCondList = data.data['list'];

        let selObj = { 'cond_list_id': '0', 'list_name': 'اختر', 'list_name_en': 'Select' };
        this.invCondList.unshift(selObj);
      });

    query = this.queryList.all_country;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.country_list = data.data['list'];
      });

    query = this.queryList.all_city;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
        this.getCity();
      });

    query = "SELECT * FROM `bus` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.bus_list = data.data['list'];
      });

    query = "SELECT * FROM `room_type` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.room_list = data.data['list'];
      });

    query = "SELECT * FROM `hotel` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.hotels = data.data['list'];
      });

    //------------------------ Edit Mode ------------------------//

    this.route.params.subscribe(params => {
      if (params['id'] != undefined) {
        this.id = params['id'];
        this.getTourProg();
      }

      if (params['mode'] != undefined)
        this.mode = params['mode'];
      console.log(this.mode);
    });
  }

  //-------********************** EDIT **********************-------//

  getTourProg() {

    //------------------------ Trip ------------------------//

    // let query = "SELECT `trip`.* FROM `trip` WHERE `trip`.`trip_id` = '" + this.id + "' AND `trip`.`status` = '1'";
    // let obj = { cmd: 'getList', query: query };
    let obj = { cmd: 'getTripDetail', trip_id: this.id };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'error') 
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        else if (data.status['type'] == 'success') {
          let result = data.status['msg'][0];

          // get trip detail
          this.trip_info = result['trip_info'];

          this.trip_model = {
            'table_name': 'trip', 'trip_id': this.trip_info['trip_id'],
            'category_id': this.trip_info['category_id'], 'trip_name': this.trip_info['trip_name'],
            'trip_number': this.trip_info['trip_number'], 'agent_only': this.trip_info['agent_only'],
            'departure_date': this.trip_info['departure_date'], 'arrival_date': this.trip_info['arrival_date'],
            'active': this.trip_info['active'], 'hijri_departure_date': this.trip_info['hijri_departure_date'],
            'hijri_arrival_date': this.trip_info['hijri_arrival_date'], 'visitors_number': this.trip_info['visitors_number'],
            'trip_activity': this.trip_info['trip_activity'], 'days_number': this.trip_info['days_number'],
            'nights_num': this.trip_info['nights_num'], 'departure_time': this.trip_info['departure_time'],
            'arrival_time': this.trip_info['arrival_time'], 'bed_price': this.trip_info['bed_price'],
            'bed_cost': this.trip_info['bed_cost'], 'bed_calc_tax': this.trip_info['bed_calc_tax'],
            'bed_tax_amount': this.trip_info['bed_tax_amount'], 'bed_supplier_no': this.trip_info['bed_supplier_no'],
            'trip_price': this.trip_info['trip_price'], 'airline_id': this.trip_info['airline_id'],
            'ticket_inc': this.trip_info['ticket_inc'], 'hotel_inc': this.trip_info['hotel_inc'],
            'price_type': this.trip_info['price_type'], 'not_mand_cust_info': this.trip_info['not_mand_cust_info'],
            'ticket_cost': this.trip_info['ticket_cost'], 'ticket_calc_tax': this.trip_info['ticket_calc_tax'],
            'ticket_tax_amount': this.trip_info['ticket_tax_amount'], 'ticket_supplier_no': this.trip_info['ticket_supplier_no'],
            'food_price': this.trip_info['food_price'], 'food_cost': this.trip_info['food_cost'],
            'food_calc_tax': this.trip_info['food_calc_tax'], 'food_tax_amount': this.trip_info['food_tax_amount'],
            'food_supplier_no': this.trip_info['food_supplier_no'], 'visa_price': this.trip_info['visa_price'],
            'visa_cost': this.trip_info['visa_cost'], 'visa_calc_tax': this.trip_info['visa_calc_tax'],
            'visa_tax_amount': this.trip_info['visa_tax_amount'], 'visa_supplier_no': this.trip_info['visa_supplier_no'],
            'price_for_tax': this.trip_info['price_for_tax'], 'tax_type': this.trip_info['tax_type'],
            'tax_no': this.trip_info['tax_no'], 'flag': 'update', 'key': 'trip_id',
            'tax_comment': this.trip_info['tax_comment'], 'price_comment': this.trip_info['price_comment'],
            'seat_price': this.trip_info['seat_price'], 'cost_center': this.trip_info['cost_center'], 
            'cond_list_id': this.trip_info['cond_list_id'], 'comment': this.trip_info['comment']
          };

          // (document.getElementById('agent_only') as HTMLInputElement).checked = (this.trip_info['agent_only'] == '1');
          this.date_model['departure_date'] = new Date(this.trip_info['departure_date']);
          this.date_model['arrival_date'] = new Date(this.trip_info['arrival_date']);

          let hijri_departure_date = this.trip_info['hijri_departure_date'];

          // depart year
          this.model['dep_year'] = hijri_departure_date.substring(0, hijri_departure_date.indexOf("-"));
          
          // depart month
          this.model['dep_month'] = Number(hijri_departure_date.substring(hijri_departure_date.indexOf("-") + 1, hijri_departure_date.lastIndexOf("-"))).toString();
          
          // depart day
          this.model['dep_day'] = Number(hijri_departure_date.substring(hijri_departure_date.lastIndexOf("-") + 1)).toString();
        

          let hijri_arrival_date = this.trip_info['hijri_arrival_date'];
          
          // arrival year
          this.model['ret_year'] = hijri_arrival_date.substring(0, hijri_arrival_date.indexOf("-"));
          
          // arrival month
          this.model['ret_month'] = Number(hijri_arrival_date.substring(hijri_arrival_date.indexOf("-") + 1, hijri_arrival_date.lastIndexOf("-"))).toString();
          
          // arrival day
          this.model['ret_day'] = Number(hijri_arrival_date.substring(hijri_arrival_date.lastIndexOf("-") + 1)).toString();
          


          this.model['ticket_cost_w_tax'] = String(Number(this.trip_model['ticket_cost']) + Number(this.trip_model['ticket_tax_amount']));
          this.model['food_cost_w_tax'] = String(Number(this.trip_model['food_cost']) + Number(this.trip_model['food_tax_amount']));
          this.model['visa_cost_w_tax'] = String(Number(this.trip_model['visa_cost']) + Number(this.trip_model['visa_tax_amount']));
    
          if (this.trip_model['airline_id'] != '0') {
            this.airline_detail = this.trip_info['airline_name'] + 
              (this.trip_info['airline_name_en'] == '' ? '' : ' - ' + this.trip_info['airline_name_en']);

            // query = "SELECT `airline`.* FROM `airline` WHERE `airline`.`airline_id` = '" +
            //   this.trip_model['airline_id'] + "' AND `airline`.`status` = '1'";

            // obj = { cmd: 'getList', query: query };
            // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            //   .subscribe(data => {
            //     this.applicationConstants.appComp.hideBusyCursor();
            //     let airline = data.data['list']; 
            //     this.airline_detail = airline['0']['airline_name'] + 
            //       (airline['0']['airline_name_en'] == '' ? '' : ' - ' + airline['0']['airline_name_en']);
            //   });
          }

          // get tax detail
          if (this.trip_model['tax_no'] != '' && this.trip_model['tax_no'] != '0') {
            this.trip_tax = result['trip_tax'];
            this.tax_detail = this.trip_tax['acct_number'] + ' - ' + this.trip_tax['tax_name_ar'] +
              ' - ' + this.trip_tax['tax_name_en'];

            //get prices with tax:
            if (this.trip_tax['tax_perc'] != '0') {
              this.model['seat_price_tax'] = (Number(this.trip_model['seat_price']) + (Number(this.trip_model['seat_price']) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
              this.model['bed_price_tax'] = (Number(this.trip_model['bed_price']) + (Number(this.trip_model['bed_price']) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
              this.model['food_price_tax'] = (Number(this.trip_model['food_price']) + (Number(this.trip_model['food_price']) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
              this.model['visa_price_tax'] = (Number(this.trip_model['visa_price']) + (Number(this.trip_model['visa_price']) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
            }
            else {
              this.model['seat_price_tax'] = (Number(this.trip_model['seat_price']) + this.trip_tax['tax_amount']).toFixed(2);
              this.model['bed_price_tax'] = (Number(this.trip_model['bed_price']) + this.trip_tax['tax_amount']).toFixed(2);
              this.model['food_price_tax'] = (Number(this.trip_model['food_price']) + this.trip_tax['tax_amount']).toFixed(2);
              this.model['visa_price_tax'] = (Number(this.trip_model['visa_price']) + this.trip_tax['tax_amount']).toFixed(2);
            }
          }

          ///------------------------ Trip City & Hotel ------------------------//

          this.trip_city = result['city_list'];
          this.trip_city_hotel = result['hotel_list'];
          this.trip_hotel_room = result['hotel_room_list'];

          let index = 0, index2 = 0, index3 = 0;
          this.trip_city.forEach(element => {

            this.add_city_list.push({
              'table_name': 'trip_city', 'trip_city_id': element.trip_city_id,
              'trip_id': element.trip_id, 'city_id': element.city_id,
              'depart_date': element.depart_date, 'arrival_date': element.arrival_date,
              'days_num': element.days_num, 'nights_num': element.nights_num,
              'transport_type': element.transport_type, 'depart_airport_id': element.depart_airport_id,
              'depart_time': element.depart_time, 'has_flight': element.has_flight,
              'night_cost': element.night_cost, 'calc_tax': element.calc_tax,
              'tax_amount': element.tax_amount, 'flag': 'update', 'key': 'trip_city_id',
              'supplier_no': element.supplier_no, 'program': element.program,
              'comment': element.comment, 'city_name': element.city_name,
              'city_name_en': element.city_name_en, 'country_id': element.country_id, 'index': index
            });

            // index2 = 0;
            this.trip_city_hotel.forEach(element2 => {

              if (element2.city_id == element.city_id && element2.depart_date == element.depart_date && 
                element2.arrival_date == element.arrival_date) {

                  this.add_hotel_list.push({
                    'table_name': 'trip_city_hotel', 'trip_hotel_id': element2.trip_hotel_id,
                    'trip_id': element2.trip_id, 'country_id': element.country_id,
                    'city_index': index, 'city_id': element2.city_id,
                    'hotel_id': element2.hotel_id, 'arrival_date': element2.arrival_date,
                    'depart_date': element2.depart_date, 'flag': 'update',
                    'key': 'trip_hotel_id', 'comment': element2.comment, 'hotel_name': element2.hotel_name,
                    'hotel_name_en': element2.hotel_name_en, 'city_name': element.city_name,
                    'city_name_en': element.city_name_en, 'index': index2
                  });

                  ///------------------------ Trip Hotel Room ------------------------//
                  // index3 = 0;
                  this.trip_hotel_room.forEach(element3 => {

                    if (element3.hotel_id == element2.hotel_id && element3.depart_date == element2.depart_date && 
                      element3.arrival_date == element2.arrival_date) {

                      this.add_hotel_room_list.push({
                        'table_name': 'trip_hotel_room', 'trip_room_id': element3.trip_room_id, 'trip_id': element3.trip_id, 
                        'room_type_id': element3.room_type_id, 'room_count': element3.room_count, 
                        'flag': 'update', 'key': 'trip_room_id', 'comment': element3.comment, 'hotel_name': element3.hotel_name, 
                        'hotel_name_en': element3.hotel_name_en, 'arrival_date': element3.arrival_date, 'depart_date': element3.depart_date, 
                        'room_type': element3.room_type, 'hotel_id': element3.hotel_id, 'index': index3, 'hotel_index': index2
                      });
                      index3++;
                    }
                    
                  });

                  index2++;
              }
              
            });

            index++;
          });

          this.cityDataSource = new MatTableDataSource(this.add_city_list);
          this.cityDataSource.sort = this.sort;

          this.cityHotelDataSource = new MatTableDataSource(this.add_hotel_list);
          this.cityHotelDataSource.sort = this.sort;

          this.hotelRoomDataSource = new MatTableDataSource(this.add_hotel_room_list);
          this.hotelRoomDataSource.sort = this.sort;

          console.log(this.add_city_list);
          console.log(this.add_hotel_list);
          console.log(this.add_hotel_room_list);


          //------------------------ Trip Bus ------------------------//

          this.trip_bus = result['bus_list'];
          index = 0;

          this.trip_bus.forEach(element => {
            this.add_bus_list.push({
              'table_name': 'trip_bus', 'trip_bus_id': element.trip_bus_id,
              'trip_id': element.trip_id, 'bus_id': element.bus_id, 'depart_date': element.depart_date,
              'return_date': element.return_date, 'flag': 'update', 'key': 'trip_bus_id',
              'from_city': element.from_city, 'to_city': element.to_city,
              'comment': element.comment, 'bus_no': element.bus_no,
              'from_city_name': element.from_city_name, 'from_city_name_en': element.from_city_name_en,
              'to_city_name': element.to_city_name, 'to_city_name_en': element.to_city_name_en,
              'index': index
            });
            this.busDataSource = new MatTableDataSource(this.add_bus_list);
            this.busDataSource.sort = this.sort;

            index++;
          });

          if (this.trip_model['tax_type'] == 'part_price') {
            if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
              if (this.trip_tax['tax_perc'] != '0')
                this.model['price_with_tax'] = (Number(this.trip_model['price_for_tax']) + (Number(this.trip_model['price_for_tax']) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
              else
                this.model['price_with_tax'] = (Number(this.trip_model['price_for_tax']) + Number(this.trip_tax['tax_amount'])).toFixed(2);
            }
          }

          // get trip price
          if (this.trip_model['price_type'] == 'room') {
            this.trip_room = result['room_list'];

            let index = 0;
            this.trip_room.forEach(element => {
              let room_price_tax = element.room_price;
              if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
                if (this.trip_model['tax_type'] == 'all_price') {
                  if (this.trip_tax['tax_perc'] != '0')
                    room_price_tax = (Number(element.room_price) + (Number(element.room_price) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
                  else
                    room_price_tax = (Number(element.room_price) + Number(this.trip_tax['tax_amount'])).toFixed(2);
                }
                else if (this.trip_model['tax_type'] == 'part_price') {
                  if (this.trip_tax['tax_perc'] != '0')
                    room_price_tax = (Number(element.room_price) + (Number(this.trip_model['price_for_tax']) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
                  else
                    room_price_tax = (Number(element.room_price) + Number(this.trip_tax['tax_amount'])).toFixed(2);
                }
              }

              this.add_room_list.push({
                'table_name': 'trip_room_price', 'room_price_id': element.room_price_id,
                'trip_id': element.trip_id, 'room_type_id': element.room_type_id,
                'room_price': element.room_price, 'room_cost': element.room_cost,
                'room_calc_tax': element.room_calc_tax, 'room_tax_amount': element.room_tax_amount,
                'flag': 'update', 'key': 'room_price_id', 'room_supplier_no': element.room_supplier_no,
                'room_price_tax': room_price_tax, 'comment': element.comment, 'room_type': element.room_type,
                'index': index
              });
              this.roomDataSource = new MatTableDataSource(this.add_room_list);
              this.roomDataSource.sort = this.sort;

              index++;
            });
          }
          else if (this.trip_model['price_type'] == 'age') {
            this.trip_age_price = result['age_list'];
            let index = 0;

            this.trip_age_price.forEach(element => {
              let price_bed_tax = element.price_bed;
              let price_no_bed_tax = element.price_no_bed;
              if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
                if (this.trip_model['tax_type'] == 'all_price') {
                  if (this.trip_tax['tax_perc'] != '0') {
                    price_bed_tax = (Number(element.price_bed) + (Number(element.price_bed) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
                    price_no_bed_tax = (Number(element.price_no_bed) + (Number(element.price_no_bed) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
                  }
                  else {
                    price_bed_tax = (Number(element.price_bed) + Number(this.trip_tax['tax_amount'])).toFixed(2);
                    price_no_bed_tax = (Number(element.price_no_bed) + Number(this.trip_tax['tax_amount'])).toFixed(2);
                  }
                }
                else if (this.trip_model['tax_type'] == 'part_price') {
                  if (this.trip_tax['tax_perc'] != '0') {
                    price_bed_tax = (Number(element.price_bed) + (Number(this.trip_model['price_for_tax']) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
                    price_no_bed_tax = (Number(element.price_no_bed) + (Number(this.trip_model['price_for_tax']) * (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
                  }
                  else {
                    price_bed_tax = (Number(element.price_bed) + Number(this.trip_tax['tax_amount'])).toFixed(2);
                    price_no_bed_tax = (Number(element.price_no_bed) + Number(this.trip_tax['tax_amount'])).toFixed(2);
                  }
                }
              }

              this.add_age_list.push({
                'table_name': 'trip_price', 'trip_price_id': element.trip_price_id, 'trip_id': element.trip_id,
                'period_from': element.period_from, 'period_to': element.period_to, 'price_bed': element.price_bed,
                'bed_cost': element.bed_cost, 'bed_calc_tax': element.bed_calc_tax, 'bed_tax_amount': element.bed_tax_amount,
                'bed_supplier_no': element.bed_supplier_no, 'price_no_bed': element.price_no_bed, 'no_bed_cost': element.no_bed_cost,
                'no_bed_calc_tax': element.no_bed_calc_tax, 'no_bed_tax_amount': element.no_bed_tax_amount,
                'flag': 'update', 'key': 'trip_price_id', 'no_bed_supplier_no': element.no_bed_supplier_no,
                'comment': element.comment, 'index': index, 'price_bed_tax': price_bed_tax, 'price_no_bed_tax': price_no_bed_tax
              });
              this.ageDataSource = new MatTableDataSource(this.add_age_list);
              this.ageDataSource.sort = this.sort;

              index++;
            });
          }

          if (this.trip_model['cost_center'] != '0') {
            let cost_center = result['cost_center'];
            this.cc_model = {
              'table_name': 'cost_center', 'cc_id': cost_center.cc_id, 'cc_number': cost_center.cc_id, 
              'cc_name': cost_center.cc_name, 'cc_name_en': cost_center.cc_name_en, 
              'cc_desc': cost_center.cc_desc, 'cc_date': cost_center.cc_date, 'flag': 'update', 
              'key': 'cc_id', 'comment': cost_center.comment
            }
          }

          if (this.mode == 'copy') {
            this.trip_model['trip_id'] = '0';
            this.trip_model['flag'] = 'new';
          }
        }

      });

  }

  //------------------------ General Functions ------------------------//

  next(event) {
    let btnId = event.srcElement.id;

    if (btnId == "btn_next1")
      this.selectedTab = 1;
    else if (btnId == "btn_next2")
      this.selectedTab = 2;
    else if (btnId == "btn_next3")
      this.selectedTab = 3;
    else if (btnId == "btn_next4")
      this.selectedTab = 4;
    else if (btnId == "btn_next5")
      this.selectedTab = 5;

    this.changeTab(null);
  }

  back(event) {
    let btnId = event.srcElement.id;

    if (btnId == "btn_back0")
      this.selectedTab = 0;
    else if (btnId == "btn_back1")
      this.selectedTab = 1;
    else if (btnId == "btn_back2")
      this.selectedTab = 2;
    else if (btnId == "btn_back3")
      this.selectedTab = 3;
    else if (btnId == "btn_back4")
      this.selectedTab = 4;

    this.changeTab(null);
  }

  changeCat() {
    this.cat_list.forEach(element => {
      if (element.category_id == this.trip_model['category_id'])
        this.trip_model['trip_name'] = element.category_name;
    });
  }

  changeDepDate() {
    this.date_model['city_dep_date'] = this.date_model['departure_date'];
    let hijri = this.writeIslamicDate(this.date_model['departure_date']);
    this.model['dep_day'] = hijri['day'];
    this.model['dep_month'] = hijri['month'];
    this.model['dep_year'] = hijri['year'];
  }

  changeRetDate(type) {
    let day_count;
    if (type == 'trip') {
      this.date_model['city_ret_date'] = this.date_model['arrival_date'];
      let hijri = this.writeIslamicDate(this.date_model['arrival_date']);
      this.model['ret_day'] = hijri['day'];
      this.model['ret_month'] = hijri['month'];
      this.model['ret_year'] = hijri['year'];

      if (this.date_model['arrival_date'] != undefined && this.date_model['departure_date'] != undefined) {
        if (this.date_model['departure_date'] > this.date_model['arrival_date'])
          alert(this.Date_Msg);

        else {
          day_count = Math.floor((Date.UTC(this.date_model['arrival_date'].getFullYear(), this.date_model['arrival_date'].getMonth(), this.date_model['arrival_date'].getDate())
            - Date.UTC(this.date_model['departure_date'].getFullYear(), this.date_model['departure_date'].getMonth(), this.date_model['departure_date'].getDate())) / (1000 * 60 * 60 * 24));

          this.trip_model['days_number'] = String(day_count + 1);
          this.trip_model['nights_num'] = String(day_count);
          this.city_model['days_num'] = String(day_count + 1);
          this.city_model['nights_num'] = String(day_count);
        }
      }
    }

    else if (type == 'city') {
      if (this.date_model['city_arr_date'] != undefined && this.date_model['city_dep_date'] != undefined) {
        if (this.date_model['city_arr_date'] > this.date_model['city_dep_date'])
          alert(this.Date_Msg);

        else {
          day_count = Math.floor((Date.UTC(this.date_model['city_dep_date'].getFullYear(), this.date_model['city_dep_date'].getMonth(), this.date_model['city_dep_date'].getDate())
            - Date.UTC(this.date_model['city_arr_date'].getFullYear(), this.date_model['city_arr_date'].getMonth(), this.date_model['city_arr_date'].getDate())) / (1000 * 60 * 60 * 24));

          this.city_model['days_num'] = String(day_count + 1);
          this.city_model['nights_num'] = String(day_count);
        }
      }
    }
  }

  writeIslamicDate(date) {
    let myFormat = 'en-u-ca-islamic-umalqura-nu-latn'; // use islamic-umalqura calendar (most modern)
    let myDate = new Date(date);
    // let output   = new Intl.DateTimeFormat('en-US',{dateStyle:'short'}).format(myDate);
    let output = new Intl.DateTimeFormat(myFormat).format(myDate);
    let hijriDate = output.split('/');
    let year = hijriDate[2].split(' ');

    let newDate = { 'day': hijriDate[1], 'month': hijriDate[0], 'year': year[0] };
    return newDate;
  }

  getCity() {
    this.city_list = [];
    this.city.forEach(element => {
      if (element.country_id == this.model['country_id'])
        this.city_list.push(element);
    });
    this.city_model['country_id'] = this.model['country_id'];
  }

  calc_tax(type) {
    if (this.model[type + '_tax_no'] != '') {
      let tax_acct = this.model[type + '_tax_no'];

      let query = "SELECT * FROM `tax` WHERE `acct_number` = '" + tax_acct + "' AND `status` = '1'";
      let obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let tax = data.data['list'];

          if (type == 'ticket' || type == 'food' || type == 'visa') {
            if (this.trip_model[type + '_calc_tax'] == '1' && this.trip_model[type + '_cost'] != '') {
              let tax_amount = Number(this.trip_model[type + '_cost']) * (Number(tax['0']['tax_perc']) / 100);
              let total_w_tax = Number(this.trip_model[type + '_cost']) + tax_amount;
              this.trip_model[type + '_tax_amount'] = tax_amount.toFixed(2);
              this.model[type + '_cost_w_tax'] = total_w_tax.toFixed(2);
            }
          }

          else if (type == 'room') {
            if (this.room_price_model['room_cost'] != '' && this.room_price_model['room_calc_tax'] == '1') {
              let tax_amount = Number(this.room_price_model['room_cost']) * (Number(tax['0']['tax_perc']) / 100);
              let total_w_tax = Number(this.room_price_model['room_cost']) + tax_amount;
              this.room_price_model['room_tax_amount'] = tax_amount.toFixed(2);
              this.model['room_cost_w_tax'] = total_w_tax.toFixed(2);
            }
          }
        });
    }
  }

  getPrice(type) {
    if (type == 'part_price') {
      if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
        if (this.trip_tax['tax_perc'] != '0')
          this.trip_model['price_for_tax'] = (Number(this.model['price_with_tax']) / (1 + (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
        else
          this.trip_model['price_for_tax'] = (Number(this.model['price_with_tax']) - this.trip_tax['tax_amount']).toFixed(2);
      }
      else
        this.trip_model['price_for_tax'] = this.model['seat_price_tax'];
    }

    else if (type == 'seat') {
      if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
        if (this.trip_tax['tax_perc'] != '0')
          this.trip_model['seat_price'] = (Number(this.model['seat_price_tax']) / (1 + (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
        else
          this.trip_model['seat_price'] = (Number(this.model['seat_price_tax']) - this.trip_tax['tax_amount']).toFixed(2);
      }
      else
        this.trip_model['seat_price'] = this.model['seat_price_tax'];
    }

    else if (type == 'bed') {
      if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
        if (this.trip_tax['tax_perc'] != '0')
          this.trip_model['bed_price'] = (Number(this.model['bed_price_tax']) / (1 + (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
        else
          this.trip_model['bed_price'] = (Number(this.model['bed_price_tax']) - this.trip_tax['tax_amount']).toFixed(2);
      }
      else
        this.trip_model['bed_price'] = this.model['bed_price_tax'];

      this.trip_model['bed_tax_amount'] = (Number(this.model['bed_price_tax']) - Number(this.trip_model['bed_price'])).toFixed(2);
    }

    else if (type == 'food') {
      if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
        if (this.trip_tax['tax_perc'] != '0')
          this.trip_model['food_price'] = (Number(this.model['food_price_tax']) / (1 + (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
        else
          this.trip_model['food_price'] = (Number(this.model['food_price_tax']) - this.trip_tax['tax_amount']).toFixed(2);
      }
      else
        this.trip_model['food_price'] = this.model['food_price_tax'];

      this.trip_model['food_tax_amount'] = (Number(this.model['food_price_tax']) - Number(this.trip_model['food_price'])).toFixed(2);
    }

    else if (type == 'visa') {
      if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
        if (this.trip_tax['tax_perc'] != '0')
          this.trip_model['visa_price'] = (Number(this.model['visa_price_tax']) / (1 + (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
        else
          this.trip_model['visa_price'] = (Number(this.model['visa_price_tax']) - this.trip_tax['tax_amount']).toFixed(2);
      }
      else
        this.trip_model['visa_price'] = this.model['visa_price_tax'];

      this.trip_model['visa_tax_amount'] = (Number(this.model['visa_price_tax']) - Number(this.trip_model['visa_price'])).toFixed(2);
    }
  }

  //------------------------ On Change Search ------------------------//

  onChangeTicketSupplier = function (search_result: object) {
    this.trip_model['ticket_supplier_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeFoodSupplier = function (search_result: object) {
    this.trip_model['food_supplier_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeVisaSupplier = function (search_result: object) {
    this.trip_model['visa_supplier_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeCitySupplier = function (search_result: object) {
    this.city_model['supplier_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeRoomSupplier = function (search_result: object) {
    this.room_price_model['room_supplier_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeAirport = function (search_result: object) {
    this.city_model['depart_airport_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeAirline = function (search_result: object) {
    this.trip_model['airline_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeTicketTax = function (search_result: object) {
    this.trip_model['tax_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
    if (this.trip_model['ticket_calc_tax'] == '1' && search_result['no'] != '') {
      this.model['ticket_tax_no'] = search_result['no'];
      this.calc_tax('ticket');
    }
  }

  onChangeCityTax = function (search_result: object) {
    this.trip_model['tax_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
    if (this.city_model['calc_tax'] == '1' && search_result['no'] != '') {
      this.model['city_tax_no'] = search_result['no'];

      let query = "SELECT * FROM `tax` WHERE `acct_number` = '" + this.model['city_tax_no'] + "' AND `status` = '1'";
      let obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.city_tax = data.data['list'];

          if (this.city_model['night_cost'] != '') {
            let total = 0;
            if (this.city_model['nights_num'] != '')
              total = Number(this.city_model['nights_num']) * Number(this.city_model['night_cost']);
            else
              total = Number(this.city_model['night_cost']);

            let tax_amount = total * (Number(this.city_tax['0']['tax_perc']) / 100);
            let total_w_tax = total + tax_amount;
            this.city_model['tax_amount'] = tax_amount.toFixed(2);
            this.model['city_total'] = total_w_tax.toFixed(2);
          }
        });
    }
  }

  onChangeFoodTax = function (search_result: object) {
    this.trip_model['tax_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
    if (this.trip_model['food_calc_tax'] == '1' && search_result['no'] != '') {
      this.model['food_tax_no'] = search_result['no'];
      this.calc_tax('food');
    }
  }

  onChangeVisaTax = function (search_result: object) {
    this.trip_model['tax_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
    if (this.trip_model['visa_calc_tax'] == '1' && search_result['no'] != '') {
      this.model['visa_tax_no'] = search_result['no'];
      this.calc_tax('visa');
    }
  }

  onChangeRoomTax = function (search_result: object) {
    this.trip_model['tax_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
    if (this.room_price_model['room_calc_tax'] == '1' && search_result['no'] != '') {
      this.model['room_tax_no'] = search_result['no'];
      this.calc_tax('room');
    }
  }

  onChangeAllTax = function (search_result: object) {
    this.trip_model['tax_no'] = (search_result['no'] != '' ? search_result['no'] : '0');

    if (search_result['no'] != '') {
      let query = "SELECT * FROM `tax` WHERE `acct_number` = '" + this.trip_model['tax_no'] + "' AND `status` = '1'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.trip_tax = data.data['list']['0'];
          console.log(this.trip_tax);
        });
    }
  }

  changeTab(event) {

    //------------------------ Edit Mode ------------------------//

    if (((event != null && event.index == 5) || (event == null && this.selectedTab == 5)) && this.trip_model['trip_id'] != '0' && this.firstVisit) {

      // (document.getElementById('all_price_for_tax') as HTMLInputElement).checked = (this.trip_info['0']['all_price_for_tax'] == '1' ? true : false);
      this.firstVisit = false;
    }
  }


  //------------------------ Check Boxes Change ------------------------//

  changeAgent() {
    this.trip_model['agent_only'] = ((document.getElementById('agent_only') as HTMLInputElement).checked ? '1' : '0');
  }

  changeHotel() {
    this.trip_model['hotel_inc'] = ((document.getElementById('hotel_inc') as HTMLInputElement).checked ? '1' : '0');
  }

  changeTicket() {
    this.trip_model['ticket_inc'] = ((document.getElementById('ticket_inc') as HTMLInputElement).checked ? '1' : '0');
  }

  changeFlight() {
    this.city_model['has_flight'] = ((document.getElementById('has_flight') as HTMLInputElement).checked ? '1' : '0');
  }

  changeTicketTax() {
    this.trip_model['ticket_calc_tax'] = ((document.getElementById('ticket_calc_tax') as HTMLInputElement).checked ? '1' : '0');
    this.calc_tax('ticket');
  }

  changeCityTax() {
    this.city_model['calc_tax'] = ((document.getElementById('calc_tax') as HTMLInputElement).checked ? '1' : '0');
    this.calc_city_total();
  }
  changeFoodTax() {
    this.trip_model['food_calc_tax'] = ((document.getElementById('food_calc_tax') as HTMLInputElement).checked ? '1' : '0');
    this.calc_tax('food');
  }

  changeVisaTax() {
    this.trip_model['visa_calc_tax'] = ((document.getElementById('visa_calc_tax') as HTMLInputElement).checked ? '1' : '0');
    this.calc_tax('visa');
  }

  changeRoomTax() {
    this.room_price_model['room_calc_tax'] = ((document.getElementById('room_calc_tax') as HTMLInputElement).checked ? '1' : '0');
    this.calc_tax('room');
  }

  changeAllPrice() {
    this.trip_model['all_price_for_tax'] = ((document.getElementById('all_price_for_tax') as HTMLInputElement).checked ? '1' : '0');
    if (this.trip_model['all_price_for_tax'] == '1') {
      (document.getElementById('price_for_tax') as HTMLInputElement).value = '0';
      (document.getElementById('price_comment') as HTMLInputElement).value = '';
    }
  }

  changePass() {
    let passOnly = (document.getElementById('pass_only') as HTMLInputElement).checked;
    this.model['pass_only'] = (passOnly ? '1' : '0');

    (document.getElementById('city_arr_date') as HTMLInputElement).disabled = passOnly;
    (document.getElementById('city_dep_date') as HTMLInputElement).disabled = passOnly;
    (document.getElementById('city_days_num') as HTMLInputElement).disabled = passOnly;
    (document.getElementById('city_nights_num') as HTMLInputElement).disabled = passOnly;
    (document.getElementById('transport_type') as HTMLInputElement).disabled = passOnly;
    (document.getElementById('search_value_3') as HTMLInputElement).disabled = passOnly;
    // (document.getElementById('search_value_5') as HTMLInputElement).disabled = passOnly;
    (document.getElementById('depart_time') as HTMLInputElement).disabled = passOnly;
    (document.getElementById('has_flight') as HTMLInputElement).disabled = passOnly;
    (document.getElementById('night_cost') as HTMLInputElement).disabled = passOnly;
    // (document.getElementById('search_value_4') as HTMLInputElement).disabled = passOnly;

    this.city_model['days_num'] = '0';
    this.city_model['nights_num'] = '0';
    this.city_model['transport_type'] = '';
    this.city_model['depart_date'] = '';
    this.city_model['has_flight'] = '0';
    this.city_model['night_cost'] = '0';
    this.city_model['supplier_no'] = '0';
    this.city_model['depart_airport_id'] = '0';
    this.city_model['depart_date'] = '';
    this.city_model['arrival_date'] = '';

  }

  //-------********************** CITY FUNCTIONS **********************-------//

  calc_city_total() {
    if (this.city_model['nights_num'] != '' && this.city_model['night_cost'] != '') {
      let total = Number(this.city_model['nights_num']) * Number(this.city_model['night_cost']);

      if (this.city_model['calc_tax'] == '1' && this.city_tax.length != 0) {
        let tax_amount = total * (Number(this.city_tax['0']['tax_perc']) / 100);
        let total_w_tax = total + tax_amount;
        this.city_model['tax_amount'] = tax_amount.toFixed(2);
        this.model['city_total'] = total_w_tax.toFixed(2);
      }
      else
        this.model['city_total'] = total.toFixed(2);
    }
  }

  saveCity() {
    if (this.city_model['city_id'] == '0') {
      alert(this.City_Msg);
      return;
    }

    this.city_list.forEach(element => {
      if (element.city_id == this.city_model['city_id']) {
        this.city_model['city_name'] = element.city_name;
        this.city_model['city_name_en'] = element.city_name_en;
      }
    });

    this.city_model['arrival_date'] = (this.date_model['city_arr_date'].getFullYear() + '-' +
      (this.date_model['city_arr_date'].getMonth() + 1) + '-' + this.date_model['city_arr_date'].getDate());

    this.city_model['depart_date'] = (this.date_model['city_dep_date'].getFullYear() + '-' +
      (this.date_model['city_dep_date'].getMonth() + 1) + '-' + this.date_model['city_dep_date'].getDate());

    if (this.city_model['trip_city_id'] == '0') {
      let city_existed = false;
      this.add_city_list.forEach(element => {
        if (element.city_id == this.city_model['city_id'] && element.arrival_date == this.city_model['arrival_date']) {
          element = this.city_model;
          city_existed = true;
        }
      });

      if (!city_existed) {
        this.city_model['index'] = this.add_city_list.length;
        this.add_city_list.push(this.city_model);
      }
    }
    else {
      this.add_city_list.forEach(element => {
        if (element.trip_city_id == this.city_model['trip_city_id']) {
          element = this.city_model;
        }
      });
    }

    this.cityDataSource = new MatTableDataSource(this.add_city_list);
    this.cityDataSource.sort = this.sort;

    this.city_model = {
      'table_name': 'trip_city', 'trip_city_id': '0', 'trip_id': this.trip_model['trip_id'], 'city_id': '0',
      'arrival_date': '', 'depart_date': '', 'days_num': '0', 'nights_num': '0', 'transport_type': '',
      'depart_airport_id': '0', 'depart_time': '', 'has_flight': '', 'night_cost': '0', 'calc_tax': '0',
      'tax_amount': '0', 'flag': 'new', 'key': 'trip_city_id', 'supplier_no': '', 'program': '', 'comment': '',
      'city_name': '', 'country_id': ''
    };

    this.model['country_id'] = '';
    this.model['city_total'] = '';

    (document.getElementById('search_value_3') as HTMLInputElement).value = '';

    this.date_model['city_arr_date'] = new Date();
    this.date_model['city_dep_date'] = new Date();

    console.log("add_city_list: ");
    console.log(this.add_city_list);
  }

  editCity(row) {
    this.city_model = row;
    this.date_model['city_arr_date'] = new Date(this.city_model['arrival_date']);
    this.date_model['city_dep_date'] = new Date(this.city_model['depart_date']);
    this.model['country_id'] = this.city_model['country_id'];
    this.getCity();

    if (row.calc_tax == '1') {
      // (document.getElementById('calc_tax') as HTMLInputElement).checked = true;

      let query, obj;
      if (this.trip_model['tax_no'] != '') {
        query = "SELECT * FROM `tax` WHERE `acct_number` = '" + this.trip_model['tax_no'] + "' AND `status` = '1'";
        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let tax = data.data['list'];
            // (document.getElementById('search_value_4') as HTMLInputElement).value =
            //   tax['0']['tax_name_en'] + ' - ' + tax['0']['tax_name_ar'] + ' - ' + tax['0']['acct_number'];
          });
      }

      if (row.depart_airport_id != '0') {
        query = "SELECT `airport`.* FROM `airport` WHERE `airport`.`airport_id` = '" + row.depart_airport_id + "' AND `airport`.`status` = '1'";
        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let airport = data.data['list'];
            (document.getElementById('search_value_3') as HTMLInputElement).value =
              airport['0']['airport_name'] + ' - ' + airport['0']['airport_name_en'] + ' - ' + airport['0']['airport_code'];
          });
      }

      if (row.supplier_no != '') {
        query = "SELECT `supplier`.* FROM `supplier` WHERE `supplier`.`acct_number` = '" + row.supplier_no + "' AND `supplier`.`status` = '1'";
        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let city_supplier = data.data['list'];
            // (document.getElementById('search_value_5') as HTMLInputElement).value =
            //   city_supplier['0']['supplier_name'] + ' - ' + city_supplier['0']['supplier_name_en'] + ' - ' + city_supplier['0']['acct_number'];
          });
      }
      this.calc_city_total();
    }
  }

  deleteCity(row) {

    let cityIndex = this.utils.getDPIndex(this.add_city_list, 'index', row.index);

    if (row.trip_city_id != '0' && this.mode != 'copy') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_city_list.splice(cityIndex, 1);
    this.cityDataSource = new MatTableDataSource(this.add_city_list);
    this.cityDataSource.sort = this.sort;
  }

  //-------********************** BUS FUNCTIONS **********************-------//

  getBusSeat() {
    this.bus_list.forEach(element => {
      if (element.bus_id == this.bus_model['bus_id'])
        this.model['bus_seat'] = element.seats_num;
    });
  }

  onChangeFromCity = function (search_result: object) {
    this.bus_model['from_city'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeToCity = function (search_result: object) {
    this.bus_model['to_city'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  saveBus() {
    if (this.bus_model['bus_id'] == '0') {
      alert(this.Bus_Msg);
      return;
    }
    this.bus_list.forEach(element => {
      if (element.bus_id == this.bus_model['bus_id']) {
        this.bus_model['bus_no'] = element.bus_no;
      }
    });

    this.city.forEach(element => {
      if (element.city_id == this.bus_model['from_city'])
        this.bus_model['from_city_name'] = element.city_name;
      this.bus_model['from_city_name_en'] = element.city_name_en;
    });

    this.city.forEach(element => {
      if (element.city_id == this.bus_model['to_city'])
        this.bus_model['to_city_name'] = element.city_name;
      this.bus_model['to_city_name_en'] = element.city_name_en;
    });

    this.bus_model['depart_date'] = (this.date_model['bus_dep_date'].getFullYear() + '-' +
      (this.date_model['bus_dep_date'].getMonth() + 1) + '-' + this.date_model['bus_dep_date'].getDate());

    this.bus_model['return_date'] = (this.date_model['bus_ret_date'].getFullYear() + '-' +
      (this.date_model['bus_ret_date'].getMonth() + 1) + '-' + this.date_model['bus_ret_date'].getDate());


    if (this.bus_model['trip_bus_id'] == '0') {
      let bus_existed = false;
      this.add_bus_list.forEach(element => {
        if (element.bus_id == this.bus_model['bus_id'] && element.from_city == this.bus_model['from_city'] && 
          element.to_city == this.bus_model['to_city'] && element.depart_date == this.bus_model['depart_date'] && 
          element.return_date == this.bus_model['return_date']) {

          element = this.bus_model;
          bus_existed = true;
        }
      });

      if (!bus_existed) {
        this.bus_model['index'] = this.add_bus_list.length;
        this.add_bus_list.push(this.bus_model);
      }
    }
    else {
      this.add_bus_list.forEach(element => {
         if (element.bus_id == this.bus_model['bus_id'] && element.from_city == this.bus_model['from_city'] && 
            element.to_city == this.bus_model['to_city'] && element.depart_date == this.bus_model['depart_date'] && 
            element.return_date == this.bus_model['return_date']) {

          element = this.bus_model;
        }
      });
    }

    this.busDataSource = new MatTableDataSource(this.add_bus_list);
    this.busDataSource.sort = this.sort;

    this.bus_model = {
      'table_name': 'trip_bus', 'trip_bus_id': '0', 'trip_id': this.trip_model['trip_id'], 'bus_id': '0',
      'depart_date': '', 'return_date': '', 'flag': 'new', 'key': 'trip_bus_id', 'from_city': '0',
      'to_city': '0', 'comment': '', 'bus_no': '', 'from_city_name': '', 'from_city_name_en': '',
      'to_city_name': '', 'to_city_name_en': ''
    };

    this.model['bus_seat'] = '';
    this.date_model['bus_dep_date'] = new Date();
    this.date_model['bus_ret_date'] = new Date();
    (document.getElementById('search_value_8') as HTMLInputElement).value = '';
    (document.getElementById('search_value_9') as HTMLInputElement).value = '';
  }

  editBus(row) {
    this.bus_model = row;
    this.date_model['bus_dep_date'] = new Date(this.bus_model['depart_date']);
    this.date_model['bus_ret_date'] = new Date(this.bus_model['return_date']);
    this.from_city_detail = row.from_city_name + (row.from_city_name_en != '' ? '-' + row.from_city_name_en : '');
    this.to_city_detail = row.to_city_name + (row.to_city_name_en != '' ? '-' + row.to_city_name_en : '');
    
    this.getBusSeat();
  }

  deleteBus(row) {

    let budIndex = this.utils.getDPIndex(this.add_bus_list, 'index', row.index);

    if (row.trip_bus_id != '0' && this.mode != 'copy') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_bus_list.splice(budIndex, 1);
    this.busDataSource = new MatTableDataSource(this.add_bus_list);
    this.busDataSource.sort = this.sort;
  }

  //-------********************** ROOM PRICE FUNCTIONS **********************-------//

  saveRoom() {
    if (this.room_price_model['room_type_id'] == '0') {
      alert(this.Room_Type_Msg);
      return;
    }

    if (this.room_price_model['room_price'] == '') {
      alert(this.Price_Msg);
      return;
    }

    if (this.room_price_model['room_price_tax'] == '' || Number(this.room_price_model['room_price_tax']) == 0) {
      this.room_price_model['room_price_tax'] = this.room_price_model['room_price'];
    }

    this.room_list.forEach(element => {
      if (element.room_type_id == this.room_price_model['room_type_id'])
        this.room_price_model['room_type'] = element.room_type;
    });

    if (this.room_price_model['room_price_id'] == '0') {
      let room_existed = false;
      this.add_room_list.forEach(element => {
        if (element.room_type_id == this.room_price_model['room_type_id']) {
          element = this.room_price_model;
          room_existed = true;
        }
      });

      if (!room_existed) {
        this.room_price_model['index'] = this.add_room_list.length;
        this.add_room_list.push(this.room_price_model);
      }
    }
    else {
      this.add_room_list.forEach(element => {
        if (element.room_price_id == this.room_price_model['room_price_id']) {
          element = this.room_price_model;
        }
      });
    }

    this.roomDataSource = new MatTableDataSource(this.add_room_list);
    this.roomDataSource.sort = this.sort;

    this.room_price_model = {
      'table_name': 'trip_room_price', 'room_price_id': '0', 'trip_id': this.trip_model['trip_id'],
      'room_type_id': '0', 'room_price': '', 'room_cost': '0', 'room_calc_tax': '0', 'room_tax_amount': '0',
      'room_price_tax': '0', 'flag': 'new', 'key': 'room_price_id', 'room_supplier_no': '', 'comment': '',
      'room_type': ''
    };

    this.model['room_cost_w_tax'] = '';

  }

  editRoomPrice(row) {
    this.room_price_model = row;
    if (this.trip_model['tax_no'] == '' || this.trip_model['tax_no'] == '0')
      this.room_price_model['room_price_tax'] = '';
  }

  deleteRoomPrice(row) {
    let roomIndex = this.utils.getDPIndex(this.add_room_list, 'index', row.index);

    if (row.room_price_id != '0' && this.mode != 'copy') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_room_list.splice(roomIndex, 1);
    this.roomDataSource = new MatTableDataSource(this.add_room_list);
    this.roomDataSource.sort = this.sort;

  }

  // ----------- Change the room price without tax --------------

  getRoomPrice() {
    //console.log(this.trip_tax);
  
    if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
      if (this.trip_model['tax_type'] == 'all_price') {
        if (this.trip_tax['tax_perc'] != '0')
          this.room_price_model['room_price'] = (Number(this.room_price_model['room_price_tax']) / (1 + (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
        else
          this.room_price_model['room_price'] = (Number(this.room_price_model['room_price_tax']) - this.trip_tax['tax_amount']).toFixed(2);
      }
      else if (this.trip_model['tax_type'] == 'part_price') 
       this.room_price_model['room_price'] = (Number(this.trip_model['price_for_tax']) + (Number(this.room_price_model['room_price_tax']) - Number(this.model['price_with_tax']))).toFixed(2);
    }
    else
      this.room_price_model['room_price'] = this.room_price_model['room_price_tax'];
  }

  //-------********************** AGE PRICE FUNCTIONS **********************-------//

  saveAge() {

    if (this.age_price_model['period_from'] == '') {
      alert(this.From_Age_Msg);
      return;
    }

    if (this.age_price_model['period_to'] == '') {
      alert(this.To_Age_Msg);
      return;
    }

    if (this.age_price_model['price_bed_tax'] == '' || Number(this.age_price_model['price_bed_tax']) == 0) {
      this.age_price_model['price_bed_tax'] = this.age_price_model['price_bed'];
    }

    if (this.age_price_model['price_no_bed_tax'] == '' || Number(this.age_price_model['price_no_bed_tax']) == 0) {
      this.age_price_model['price_no_bed_tax'] = this.age_price_model['price_no_bed'];
    }

    if (this.age_price_model['trip_price_id'] == '0') {
      let age_existed = false;
      this.add_age_list.forEach(element => {
        if (element.period_from == this.age_price_model['period_from'] && element.period_to == this.age_price_model['period_to']) {
          element = this.age_price_model;
          age_existed = true;
        }
      });

      if (!age_existed) {
        this.age_price_model['index'] = this.add_age_list.length;
        this.add_age_list.push(this.age_price_model);
      }
    }
    else {
      this.add_age_list.forEach(element => {
        if (element.trip_price_id == this.age_price_model['trip_price_id']) {
          element = this.age_price_model;
        }
      });
    }

    this.ageDataSource = new MatTableDataSource(this.add_age_list);
    this.ageDataSource.sort = this.sort;

    this.age_price_model = {
      'table_name': 'trip_price', 'trip_price_id': '0', 'trip_id': this.trip_model['trip_id'], 'period_from': '', 'period_to': '',
      'price_bed': '', 'bed_cost': '0', 'bed_calc_tax': '0', 'bed_tax_amount': '0', 'bed_supplier_no': '0',
      'price_no_bed': '', 'no_bed_cost': '0', 'no_bed_calc_tax': '0', 'no_bed_tax_amount': '0',
      'flag': 'new', 'key': 'trip_price_id', 'no_bed_supplier_no': '0', 'comment': '',
      'price_bed_tax': '', 'price_no_bed_tax': ''
    };

  }

  editAgePrice(row) {
    this.age_price_model = row;
    // if (this.trip_model['tax_no'] == '' || this.trip_model['tax_no'] == '0')
    //   this.room_price_model['room_price_tax'] = '';
  }

  deleteAgePrice(row) {
    let ageIndex = this.utils.getDPIndex(this.add_age_list, 'index', row.index);

    if (row.trip_price_id != '0' && this.mode != 'copy') {
      row.flag = 'delete';
      this.toDelete.push(row);
      console.log(this.toDelete);
    }

    this.add_age_list.splice(ageIndex, 1);
    this.ageDataSource = new MatTableDataSource(this.add_age_list);
    this.ageDataSource.sort = this.sort;
  }

  // ----------- Change the age price without tax --------------

  getAgePrice(type) {

    if (type == 'bed') {
      if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
        if (this.trip_model['tax_type'] == 'all_price') {
          if (this.trip_tax['tax_perc'] != '0')
            this.age_price_model['price_bed'] = (Number(this.age_price_model['price_bed_tax']) / (1 + (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
          else
            this.age_price_model['price_bed'] = (Number(this.age_price_model['price_bed_tax']) - this.trip_tax['tax_amount']).toFixed(2);
        }
        else if (this.trip_model['tax_type'] == 'part_price') 
          this.age_price_model['price_bed'] = (Number(this.trip_model['price_for_tax']) + (Number(this.age_price_model['price_bed_tax']) - Number(this.model['price_with_tax']))).toFixed(2);
      }
      else
        this.age_price_model['price_bed'] = this.age_price_model['price_bed_tax'];
    }

    else if (type == 'no_bed') {
      if (this.trip_model['tax_no'] != '0' && this.trip_model['tax_no'] != '') {
        if (this.trip_model['tax_type'] == 'all_price') {
          if (this.trip_tax['tax_perc'] != '0')
            this.age_price_model['price_no_bed'] = (Number(this.age_price_model['price_no_bed_tax']) / (1 + (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
          else
            this.age_price_model['price_no_bed'] = (Number(this.age_price_model['price_no_bed_tax']) - this.trip_tax['tax_amount']).toFixed(2);
        }
        else if (this.trip_model['tax_type'] == 'part_price') 
          this.age_price_model['price_no_bed'] = (Number(this.trip_model['price_for_tax']) + (Number(this.age_price_model['price_no_bed_tax']) - Number(this.model['price_with_tax']))).toFixed(2);
      }
      else
        this.age_price_model['price_no_bed'] = this.age_price_model['price_no_bed_tax'];
    }
  }

  //-------********************** CITY HOTEL FUNCTIONS **********************-------//

  getCityHotel() {
    this.hotel_list = [];
    // console.log(this.add_city_list);
    this.add_city_list.forEach(element => {
      if (element.index == this.city_hotel_model['city_index']) {
        this.city_hotel_model['city_id'] = element.city_id;
        this.city_hotel_model['city_name'] = element.city_name;
        this.city_hotel_model['city_name_en'] = element.city_name_en;

        this.city_hotel_model['arrival_date'] = element.arrival_date;
        this.city_hotel_model['depart_date'] = element.depart_date;
      }
    });

    // console.log(this.city_hotel_model);
    this.hotels.forEach(element => {
      if (element.city_id == this.city_hotel_model['city_id'])
        this.hotel_list.push(element);
    });
    this.hotel_list.unshift({ 'hotel_id': '0', 'hotel_name': 'اختر', 'hotel_name_en': 'Select' });
  }

  saveHotel() {
    if (this.city_hotel_model['city_index'] == '') {
      alert(this.City_Msg);
      return;
    }

    if (this.city_hotel_model['hotel_id'] == '0') {
      alert(this.Hotel_Msg);
      return;
    }

    this.add_city_list.forEach(element => {
      if (element.index == this.city_hotel_model['city_index']) {
        this.city_hotel_model['arrival_date'] = element.arrival_date;
        this.city_hotel_model['depart_date'] = element.depart_date;
      }
    });

    this.hotel_list.forEach(element => {
      if (element.hotel_id == this.city_hotel_model['hotel_id']) {
        this.city_hotel_model['hotel_name'] = element.hotel_name;
        this.city_hotel_model['hotel_name_en'] = element.hotel_name_en;
      }
    });

    // if (this.city_hotel_model['trip_hotel_id'] == '0') 
    if (this.city_hotel_model['trip_hotel_id'] == '0') {
      let hotel_existed = false;
      this.add_hotel_list.forEach(element => {
        if (element.hotel_id == this.city_hotel_model['hotel_id'] && element.arrival_date == this.city_hotel_model['arrival_date']) {
          element = this.city_hotel_model;
          hotel_existed = true;
        }
      });

      if (!hotel_existed) {
        this.city_hotel_model['index'] = this.add_hotel_list.length;
        this.add_hotel_list.push(this.city_hotel_model);
      }
    }
    else {
      this.add_hotel_list.forEach(element => {
        if (element.trip_hotel_id == this.city_hotel_model['trip_hotel_id']) {
          element = this.city_hotel_model;
        }
      });
    }

    this.cityHotelDataSource = new MatTableDataSource(this.add_hotel_list);
    this.cityHotelDataSource.sort = this.sort;

    this.city_hotel_model = {
      'table_name': 'trip_city_hotel', 'trip_hotel_id': '0', 'trip_id': '0', 'country_id': '0',
      'city_index': '', 'city_id': '0', 'hotel_id': '0', 'arrival_date': '', 'depart_date': '',
      'flag': 'new', 'key': 'trip_hotel_id', 'comment': '', 'hotel_name': '', 'hotel_name_en': '',
      'city_name': '', 'city_name_en': ''
    };

    console.log("add_hotel_list: ");
    console.log(this.add_hotel_list);
  }

  editHotel(row) {
    this.city_hotel_model = row;
    this.getCityHotel();
  }

  deleteHotel(row) {
    let hotelIndex = this.utils.getDPIndex(this.add_hotel_list, 'index', row.index);

    // if (row.trip_hotel_id != '0' && this.mode != 'copy') {
    //   row.flag = 'delete';
    //   this.toDelete.push(row);
    // }

    this.add_hotel_list.splice(hotelIndex, 1);
    this.cityHotelDataSource = new MatTableDataSource(this.add_hotel_list);
    this.cityHotelDataSource.sort = this.sort;

    if (this.add_hotel_list.length > 0)
      this.hotel_room_model['trip_hotel_id'] = this.add_hotel_list[0]['trip_hotel_id'];
  }

  saveHotelRoom() {
    if (this.hotel_room_model['hotel_index'] == '') {
      alert(this.Hotel_Msg);
      return;
    }

    if (this.hotel_room_model['room_type_id'] == '0') {
      alert(this.Room_Type_Msg);
      return;
    }

    if (Number(this.hotel_room_model['room_count']) == 0) {
      alert(this.Room_Count_Msg);
      return;
    }

    this.add_hotel_list.forEach(element => {
      if (element.index == this.hotel_room_model['hotel_index']) {
        this.hotel_room_model['hotel_id'] = element.hotel_id;
        this.hotel_room_model['hotel_name'] = element.hotel_name;
        this.hotel_room_model['hotel_name_en'] = element.hotel_name_en;
        this.hotel_room_model['arrival_date'] = element.arrival_date;
        this.hotel_room_model['depart_date'] = element.depart_date;
      }
    });

    this.room_list.forEach(element => {
      if (element.room_type_id == this.hotel_room_model['room_type_id']) {
        this.hotel_room_model['room_type'] = element.room_type;
      }
    });

    if (this.hotel_room_model['trip_room_id'] == '0') {
      let hotel_room_existed = false;
      this.add_hotel_room_list.forEach(element => {
        if (element.index == this.hotel_room_model['hotel_index'] && element.room_type_id == this.hotel_room_model['room_type_id']) {
          element.room_count = this.hotel_room_model['room_count'];
          element.comment = this.hotel_room_model['comment'];
          element = this.hotel_room_model;
          hotel_room_existed = true;
        }
      });

      if (!hotel_room_existed) {
        this.hotel_room_model['index'] = this.add_hotel_room_list.length;
        this.add_hotel_room_list.push(this.hotel_room_model);
      }
    }
    else {
      this.add_hotel_room_list.forEach(element => {
        if (element.index == this.hotel_room_model['hotel_index'] && element.room_type_id == this.hotel_room_model['room_type_id']) {
          element = this.hotel_room_model;
        }
      });
    }

    this.hotelRoomDataSource = new MatTableDataSource(this.add_hotel_room_list);
    this.hotelRoomDataSource.sort = this.sort;

    this.hotel_room_model = {
      'table_name': 'trip_hotel_room', 'trip_room_id': '0', 'trip_id': '0', 'hotel_index': '', 
      'hotel_id': '0', 'arrival_date': '', 'depart_date': '', 'room_type_id': '0', 'room_count': '0', 'flag': 'new', 
      'key': 'trip_room_id', 'comment': '', 'hotel_name': '', 'hotel_name_en': '', 'room_type': ''
    };
    // this.hotel_room_model = {
    //   'table_name': 'trip_hotel_room', 'trip_room_id': '0', 'trip_id': '0', 'trip_hotel_id': '0', 'room_type_id': '0', 
    //   'room_count': '0', 'flag': 'new', 'key': 'trip_room_id', 'comment': '', 'hotel_name': '', 'hotel_name_en': '', 
    //   'arrival_date': '', 'depart_date': '', 'room_type': ''
    // };

    console.log("add_hotel_room_list: ");
    console.log(this.add_hotel_room_list);
  }

  editHotelRoom(row) {
    this.hotel_room_model = row;
  }

  deleteHotelRoom(row) {
    let hotelRoomIndex = this.utils.getDPIndex(this.add_hotel_room_list, 'index', row.index);

    // if (row.trip_room_id != '0' && this.mode != 'copy') {
    //   row.flag = 'delete';
    //   this.toDelete.push(row);
    // }

    this.add_hotel_room_list.splice(hotelRoomIndex, 1);
    this.hotelRoomDataSource = new MatTableDataSource(this.add_hotel_room_list);
    this.hotelRoomDataSource.sort = this.sort;
  }

  //-------********************** SVAE TRIP **********************-------//

  add() {

    if (this.trip_model['tax_type'] != 'no_tax' && (this.trip_model['tax_no'] == '0' || this.trip_model['tax_no'] == '')) {
      alert(this.Tax_Msg);
      return;
    }

    let values = [];
    let obj;

    //------------------------ Trip ------------------------//

    this.trip_model['departure_date'] = (this.date_model['departure_date'].getFullYear() + '-' +
      (this.date_model['departure_date'].getMonth() + 1) + '-' + this.date_model['departure_date'].getDate());

    this.trip_model['arrival_date'] = (this.date_model['arrival_date'].getFullYear() + '-' +
      (this.date_model['arrival_date'].getMonth() + 1) + '-' + this.date_model['arrival_date'].getDate());

    this.trip_model['hijri_departure_date'] = this.model['dep_year'] + '-' + this.model['dep_month'] + '-' + this.model['dep_day'];
    this.trip_model['hijri_arrival_date'] = this.model['ret_year'] + '-' + this.model['ret_month'] + '-' + this.model['ret_day'];

    values.push(this.trip_model);

    //------------------------ Trip City ------------------------//

    this.add_city_list.forEach(city => {
      values.push({
        'table_name': 'trip_city', 'trip_city_id': (this.mode == 'copy' ? '0' : city.trip_city_id),
        'trip_id': this.trip_model['trip_id'], 'city_id': city.city_id, 'depart_date': city.depart_date,
        'arrival_date': city.arrival_date,
        'days_num': city.days_num, 'nights_num': city.nights_num, 'transport_type': city.transport_type,
        'depart_airport_id': city.depart_airport_id, 'depart_time': city.depart_time, 'has_flight': '0',
        'night_cost': city.night_cost, 'calc_tax': city.calc_tax, 'tax_amount': city.tax_amount,
        'flag': (this.mode == 'copy' ? 'new' : city.flag), 'key': 'trip_city_id',
        'supplier_no': city.supplier_no, 'program': city.program,
        'comment': city.comment
      });
    });

    //------------------------ Trip City Hotel ------------------------//

    this.add_hotel_list.forEach(hotel => {
      values.push({
        'table_name': 'trip_city_hotel', 'trip_hotel_id': (this.mode == 'copy' ? '0' : hotel.trip_hotel_id), 
        'trip_id': this.trip_model['trip_id'], 'country_id': hotel.country_id, 'city_id': hotel.city_id, 'hotel_id': hotel.hotel_id, 
        'arrival_date': hotel.arrival_date, 'depart_date': hotel.depart_date, 'flag': (this.mode == 'copy' ? 'new' : hotel.flag), 
        'key': 'trip_hotel_id', 'comment': hotel.comment
      });
    });

    //------------------------ Trip Hotel Room ------------------------//

    this.add_hotel_room_list.forEach(hotelRoom => {
      values.push({
        'table_name': 'trip_hotel_room', 'trip_room_id': (this.mode == 'copy' ? '0' : hotelRoom.trip_room_id), 
        'trip_id': this.trip_model['trip_id'], 'hotel_id': hotelRoom.hotel_id, 
        'arrival_date': hotelRoom.arrival_date, 'depart_date': hotelRoom.depart_date, 'room_type_id': hotelRoom.room_type_id, 
        'room_count': hotelRoom.room_count, 'flag': (this.mode == 'copy' ? 'new' : hotelRoom.flag), 'key': 'trip_room_id', 
        'comment': hotelRoom.comment
      });
    });

    //------------------------ Trip Bus ------------------------//

    this.add_bus_list.forEach(bus => {
      values.push({
        'table_name': 'trip_bus', 'trip_bus_id': (this.mode == 'copy' ? '0' : bus.trip_bus_id), 'trip_id': this.trip_model['trip_id'],
        'bus_id': bus.bus_id, 'depart_date': bus.depart_date, 'return_date': bus.return_date,
        'flag': (this.mode == 'copy' ? 'new' : bus.flag), 'key': 'trip_bus_id', 'from_city': bus.from_city,
        'to_city': bus.to_city, 'comment': bus.comment
      });
    });

    //------------------------ Trip Room Price ------------------------//

    if (this.trip_model['price_type'] == 'room') {
      this.add_room_list.forEach(room => {
        values.push({
          'table_name': 'trip_room_price', 'room_price_id': (this.mode == 'copy' ? '0' : room.room_price_id), 'trip_id': this.trip_model['trip_id'],
          'room_type_id': room.room_type_id, 'room_price': room.room_price, 'room_cost': room.room_cost,
          'room_calc_tax': room.room_calc_tax, 'room_tax_amount': room.room_tax_amount,
          'flag': (this.mode == 'copy' ? 'new' : room.flag), 'key': 'room_price_id', 'room_supplier_no': room.room_supplier_no,
          'comment': room.comment
        });
      });
    }

    //------------------------ Trip Age Price ------------------------//

    if (this.trip_model['price_type'] == 'age') {
      this.add_age_list.forEach(age => {
        values.push({
          'table_name': 'trip_price', 'trip_price_id': (this.mode == 'copy' ? '0' : age.trip_price_id), 'trip_id': this.trip_model['trip_id'],
          'period_from': age.period_from, 'period_to': age.period_to, 'price_bed': age.price_bed,
          'bed_cost': age.bed_cost, 'bed_calc_tax': age.bed_calc_tax, 'bed_tax_amount': age.bed_tax_amount,
          'bed_supplier_no': age.bed_supplier_no, 'price_no_bed': age.price_no_bed, 'no_bed_cost': age.no_bed_cost,
          'no_bed_calc_tax': age.no_bed_calc_tax, 'no_bed_tax_amount': age.no_bed_tax_amount,
          'flag': (this.mode == 'copy' ? 'new' : age.flag), 'key': 'trip_price_id', 'no_bed_supplier_no': age.no_bed_supplier_no,
          'comment': age.comment
        });
      });
    }

    if (this.trip_model['trip_id'] != '0') {

      let existed = false;
      this.trip_city_hotel.forEach(element => {
        existed = false;
        for (let index = 0; index < this.add_hotel_list.length; index++) {
          if (this.add_hotel_list[index]['trip_hotel_id'] != '0' && 
            this.add_hotel_list[index]['trip_hotel_id'] == element.trip_hotel_id) {
              existed = true;
              break;
            }
        }

        if (!existed) {
          element.table_name = 'trip_city_hotel';
          element.flag = 'delete';
          this.toDelete.push(element);
        }
      });

      existed = false;
      this.trip_hotel_room.forEach(element => {
        existed = false;
        for (let index = 0; index < this.add_hotel_room_list.length; index++) {
          if (this.add_hotel_room_list[index]['trip_room_id'] != '0' && 
            this.add_hotel_room_list[index]['trip_room_id'] == element.trip_room_id) {
              existed = true;
              break;
            }
        }

        if (!existed) {
          element.table_name = 'trip_hotel_room';
          element.flag = 'delete';
          this.toDelete.push(element);
        }
      });
    }


    // add/ update cost center to values
    if (this.trip_model['trip_id'] == '0' || (this.trip_model['trip_id'] != '0' && this.cc_model.cc_id != '0')) {
      
      this.cc_model['cc_id'] = (this.mode == 'copy' ? '0' : this.cc_model['cc_id']);
      this.cc_model['flag'] = (this.mode == 'copy' ? 'new' : this.cc_model['flag']);
      this.cc_model['cc_number'] = this.trip_model['trip_number'];
      this.cc_model['cc_name'] = this.trip_model['trip_name'] + " - " + this.trip_model['trip_number'] + 
        " - " + this.trip_model['departure_date'];
      this.cc_model['cc_name_en'] = this.trip_model['trip_name'] + " - " + this.trip_model['trip_number'] + 
        " - " + this.trip_model['departure_date'];
      this.cc_model['cc_desc'] = this.trip_model['trip_name'] + " - " + this.trip_model['trip_number'] + 
        " - " + this.trip_model['departure_date'];
      this.cc_model['cc_date'] = this.trip_model['departure_date'];
      this.cc_model['comment'] = this.trip_model['trip_name'] + " - " + this.trip_model['trip_number'] + 
        " - " + this.trip_model['departure_date'];

      values.push(this.cc_model);
    }

    //------------------------ Delete ------------------------//
    if (this.trip_model['trip_id'] != '0') {
      console.log(this.toDelete);
      this.toDelete.forEach(delElem => {
        if (delElem['table_name'] == 'trip_city') {
          values.push({
            'table_name': delElem['table_name'], 'trip_city_id': delElem.trip_city_id,
            'key': 'trip_city_id', 'flag': 'delete', 'trip_id': this.trip_model['trip_id']
          });
        }
        else if (delElem['table_name'] == 'trip_city_hotel') {
          values.push({
            'table_name': delElem['table_name'], 'trip_hotel_id': delElem.trip_hotel_id,
            'key': 'trip_hotel_id', 'flag': 'delete', 'trip_id': this.trip_model['trip_id']
          });
        } 
        else if (delElem['table_name'] == 'trip_hotel_room') {
          values.push({
            'table_name': delElem['table_name'], 'trip_room_id': delElem.trip_room_id,
            'key': 'trip_room_id', 'flag': 'delete', 'trip_id': this.trip_model['trip_id']
          });
        }
        else if (delElem['table_name'] == 'trip_bus') {
          values.push({
            'table_name': delElem['table_name'], 'trip_bus_id': delElem.trip_bus_id,
            'key': 'trip_bus_id', 'flag': 'delete', 'trip_id': this.trip_model['trip_id']
          });
        }
        else if (delElem['table_name'] == 'trip_price') {
          values.push({
            'table_name': delElem['table_name'], 'trip_price_id': delElem.trip_price_id,
            'key': 'trip_price_id', 'flag': 'delete', 'trip_id': this.trip_model['trip_id']
          });
        }
        else if (delElem['table_name'] == 'trip_room_price') {
          values.push({
            'table_name': delElem['table_name'], 'room_price_id': delElem.room_price_id,
            'key': 'room_price_id', 'flag': 'delete', 'trip_id': this.trip_model['trip_id']
          });
        }
      });
    }

    //------------------------ Save ------------------------//

    console.log(values);
    if (this.trip_model['trip_id'] == '0') 
      obj = { cmd: 'add', values: values, pk: 'trip_id', id: 'trip_id', main_table: 'trip', prefix: '' };
    
    else 
      obj = { cmd: 'updateAdv', values: values };
    

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {

          if (this.trip_model['trip_id'] == '0') {
            let result = data.status['msg'];

            // get the id of the added cost center
            for (let index = 0; index < result.length; index++) {
              if (result[index]['table_name'] == this.cc_model['table_name']) {
                this.cc_model['cc_id'] = result[index]['id'];
                break;
              }
            }
            
            // update the cost center field in trip
            values = [{ 'table_name': this.trip_model['table_name'], 'cost_center': this.cc_model['cc_id'] }];
            let where = [{ 'trip_id': result[0]['id'] }];
            obj = { cmd: 'update', values: values, where: where };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                //console.log(data);
                this.applicationConstants.appComp.hideBusyCursor();
                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.router.navigate(['sub_menu/13/tour_prog_list']);
                }
                else 
                  alert(this.Error_Msg);
                
              });
          }
          else {
            alert(this.Success_Msg);
            this.router.navigate(['sub_menu/13/tour_prog_list']);
          }
        }
        else
          alert(this.Error_Msg);
      });
  }
}
